import {
  getProjectKey,
  getProjectsKey,
  useGetProject,
  useUpdateProject,
} from 'api-hooks/projects';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import { queryClient } from 'common/repositories/query-client';
import LoadingComponent from 'components/common/loading';
import notification from 'components/common/notification';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import { DetailContainer } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import { NavigationProps } from 'types';

import ProjectForm from './component/form';

export type ProjectViewParams = {
  id: string;
};

export default function ProjectView(
  props: NavigationProps<NavigationRoutes.ProjectView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } = useGetProject({
    id,
  });

  const { mutateAsync, error: errorMutate } = useUpdateProject();

  const project = data?.data;

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          {!!errorMutate && !!errorMutate.message && (
            <>
              <Notification
                overrides={{
                  Body: { style: { width: 'auto', wordBreak: 'break-all' } },
                }}
                kind={KIND.negative}
                closeable
              >
                {() => errorMutate.message}
              </Notification>
            </>
          )}
          <ProjectForm
            {...props}
            project={project}
            onSubmit={async (input, form) => {
              const result = await mutateAsync({
                body: input,
                projectId: project!.id,
              });

              queryClient.refetchQueries([getProjectsKey()[0]]);
              queryClient.refetchQueries(getProjectKey({ id: result.data.id }));
              notification.success({ message: result?.message });

              return result.data;
            }}
          />
        </>
      }
    />
  );
}
